import styled from 'styled-components';
import { ApModal, colors } from '@alixpartners/ui-components';

export const StyledModal = styled(ApModal)`
	.ap-modal-lightbox {
		background-color: rgba(50, 50, 50, 0.3);
	}
	.ap-modal-content {
		max-width: 576px;
		border-radius: 1px;
		box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.25);
		max-height: 100%;
		height: 579px;
	}

	.ap-modal-footer {
		padding: 0 32px;
		display: flex;
		height: 59px;
		min-height: 59px;

		.ap-button-group {
			margin-left: auto;
		}
	}

	.ap-modal-header {
		padding: 12px 16px 11px 32px;
	}

	.ap-modal-body {
		padding: 0;
		height: 100%;
		overflow: hidden;
		display: flex;
		flex-direction: column;
	}
`;

export const Title = styled.div`
	font-weight: 700;
	font-size: 19px;
	line-height: 27px;
	color: ${colors.grey8};
	padding: 20px 0;
`;

export const Text = styled.div`
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;

	${({ bold }) => bold && 'font-weight: 700;'};
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow: hidden;
`;

export const LoadingContainer = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
`;

export const TableWrapper = styled.div`
	width: 100%;
	height: 100%;
	overflow: auto;
	padding: 0 32px 32px 32px;
	display: flex;
	flex-direction: column;
`;

export const Cell = styled.div`
	color: ${colors.grey8};
	display: flex;
	align-items: center;
	font-size: 13px;
	letter-spacing: 0.3px;
	line-height: 19px;
	height: 36px;
`;

export const Row = styled.div`
	display: grid;
	grid-template-columns: 60px minmax(128px, 1fr) 110px 128px;
	grid-auto-flow: column;
	width: fit-content;
	min-width: 100%;
	border-bottom: 1px solid ${colors.grey2};

	${Cell} {
		padding: 0 12px;
	}
`;

export const HeaderCell = styled(Cell)`
	font-size: 11px;
	line-height: 13px;
	color: ${colors.grey5};
`;

export const CellNumber = styled(Cell)`
	justify-content: flex-end;
`;

export const HeaderCellNumber = styled(HeaderCell)`
	justify-content: flex-end;
`;
